import styled from 'styled-components';

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;

  height: 30rem;
  width: 100%;
  max-width: 1500px;
  padding: 4rem 0 0 0;

  @media (max-width: 576px) {
    padding: 0;
  }
`;

export const InnerImageWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  position: relative;
  flex: 4;
`;

export const MyImage = styled.img``;
